import { render, staticRenderFns } from "./CertificatesStatusBlock.vue?vue&type=template&id=0800268f&scoped=true"
import script from "./CertificatesStatusBlock.vue?vue&type=script&lang=js"
export * from "./CertificatesStatusBlock.vue?vue&type=script&lang=js"
import style0 from "./CertificatesStatusBlock.vue?vue&type=style&index=0&id=0800268f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0800268f",
  null
  
)

export default component.exports